// @cortex/sdk-access-client: the headless typed client of the access SDK (ADR 0060), generated from the SDK's own
// OpenAPI document (../openapi.json, written by the server's `openapi:write`). Any UI uses it — the SDK's React views,
// a custom page, a script — against any host that mounts the SDK, at the base URL the host mounts it under.
import createClient, { type Client, type Middleware } from 'openapi-fetch';
import type { paths } from './generated/schema.ts';

export type { components, paths } from './generated/schema.ts';

/** Where the routes are and how to authenticate. */
export interface AccessClientOptions {
  /** Where the host mounts the SDK's routes (e.g. `/api/access`; `''`-relative in a browser on the host's origin). */
  baseUrl: string;
  /** A bearer token for each call (the host's session); null or undefined sends none. */
  token: () => Promise<string | null | undefined> | string | null | undefined;
  fetch?: typeof fetch;
}

export type AccessClient = Client<paths>;

/** The typed client: `GET`, `POST`, … over the SDK's paths, with the host's bearer on every call. */
export function createAccessClient({ baseUrl, token, fetch: f }: AccessClientOptions): AccessClient {
  const client = createClient<paths>({ baseUrl, ...(f ? { fetch: f } : {}) });
  const auth: Middleware = {
    async onRequest({ request }) {
      const t = await token();
      if (t) request.headers.set('authorization', `Bearer ${t}`);
      return request;
    },
  };
  client.use(auth);
  return client;
}
